 <template v-if="formItem.element">
    <a-row :gutter="16">
      <a-col :span="24" v-if="formItem.img">
        <j-image-draw
          v-if="isDrawImg"
          :isdraw="`${formItem.draw}`"
          :imgUrl="`${formItem.img}`"
          :drawImg="`${formItem.drawImg}`"
          :issave="true"
          :bizPath="`/project/${projectId}/patient/form/${formItem.id}`"
          @change="saveDrawChange"
        />
        <j-image-draw
          v-else
          :imgUrl="`${formItem.drawImg || formItem.img}`"
        />
      </a-col>

      <a-col :span="24">
        <a-space direction="horizontal" :size="16" class="auto-distribute">
          <!-- 单行文本 -->
          <a-input
            v-if="formItem.element.type === elementTypeData.text.value"
            :id="formItem.id + '_input'"
            :disabled="!isEdit"
            @blur="valueChange"
            v-model="form[formItem.id]"
            placeholder="请输入"
            :maxLength="maxInputLength"
          />

          <!-- 多行文本 -->
          <a-textarea
            v-else-if="formItem.element.type === elementTypeData.textarea.value"
            :id="formItem.id + '_input'"
            :disabled="!isEdit"
            @blur="valueChange"
            v-model="form[formItem.id]"
            placeholder="请输入"
            :rows="2"
            :maxLength="maxInputLength"
          />

          <!-- 数字 -->
          <template v-else-if="formItem.element.type === elementTypeData.number.value">
              <a-input-number :disabled="!isEdit" :max="(formItem.element.length !== undefined && formItem.element.length !== null) ? formItem.element.length : undefined" :readOnly="true"
                @blur="valueChange" v-model="form[formItem.id]" placeholder="请输入"
                :min="(formItem.element.minLength !== undefined && formItem.element.minLength !== null) ? formItem.element.minLength : undefined" :precision="formItem.element.reDecimal === '1' ? (formItem.element.decimalPoint===null?2:formItem.element.decimalPoint) : 0"
                style="width: 100%"  />
            </template>

          <!-- 日期时间 -->
          <a-date-picker
            v-else-if="formItem.element.type === elementTypeData.dateTime.value"
            :disabled="!isEdit"
            :inputReadOnly="isPad"
            @change="valueChange"
            value-format="YYYY-MM-DD HH:mm:ss"
            show-time
            v-model="form[formItem.id]"
            allowClear
          />

          <!-- 单选 -->
          <a-radio-group
            v-else-if="formItem.element.type === elementTypeData.select.value"
            :disabled="!isEdit"
            @change="valueChange"
            v-model="form[formItem.id]"
          >
            <a-radio
              @click="clickHandle(dictItem.value)"
              class="row-block"
              :value="dictItem.value"
              v-for="(dictItem, index) in formItem.element.dictItemList"
              :key="index"
            >
              {{ dictItem.text }}
              <a-tooltip placement="topLeft" v-if="dictItem.description">
                <template slot="title">
                  {{ dictItem.description }}
                </template>
                <a-icon type="info-circle" style="color: blue" />
              </a-tooltip>
              <j-image-draw v-if="dictItem.img" :imgUrl="`${dictItem.img}`" />
            </a-radio>
          </a-radio-group>

          <!-- 多选 -->
          <a-checkbox-group
            v-else-if="formItem.element.type === elementTypeData.check.value"
            :disabled="!isEdit"
            @change="valueChange"
            v-model="form[formItem.id]"
          >
            <a-checkbox
              class="row-block"
              :style="index === 0 ? { marginLeft: '8px' } : {}"
              :value="dictItem.value"
              v-for="(dictItem, index) in formItem.element.dictItemList"
              :key="index"
            >
              {{ dictItem.text }}
              <j-image-draw v-if="dictItem.img" :imgUrl="`${dictItem.img}`" />
            </a-checkbox>
          </a-checkbox-group>

          <!-- 日期 -->
          <a-date-picker
            v-else-if="formItem.element.type === elementTypeData.date.value"
            :disabled="!isEdit"
            :inputReadOnly="isPad"
            @change="valueChange"
            value-format="YYYY-MM-DD"
            v-model="form[formItem.id]"
            allowClear
          />

           <!-- 年月 -->
          <a-month-picker
              v-else-if="formItem.element.type === elementTypeData.dateyear.value"
              :disabled="!isEdit"
              :inputReadOnly="isPad"
              @change="valueChange"
              value-format="YYYY-MM"
              format="YYYY-MM"
              v-model="form[formItem.id]"
              allowClear
              placeholder="请选择年月"
            />


          <!-- 时分 -->
          <a-time-picker
            v-else-if="formItem.element.type === elementTypeData.time.value"
            class="main"
            :disabled="!isEdit"
            :inputReadOnly="isPad"
            @change="valueChange"
            value-format="HH:mm"
            format="HH:mm"
            v-model="form[formItem.id]"
            :open.sync="timeOpen"
            allowClear
          >
            <a-button slot="addon" size="small" type="primary" @click="handleTimeClose">
              关闭
            </a-button>
          </a-time-picker>

           <!-- 时分秒 -->
          <a-time-picker
            v-else-if="formItem.element.type === elementTypeData.hour.value"
            class="main"
            :disabled="!isEdit"
            :inputReadOnly="isPad"
            @change="valueChange"
            value-format="HH:mm:ss"
            format="HH:mm:ss"
            v-model="form[formItem.id]"
            :open.sync="timeOpen"
            allowClear
          >
            <a-button slot="addon" size="small" type="primary" @click="handleTimeClose">
              关闭
            </a-button>
          </a-time-picker>

          <!-- 分秒 -->
          <a-time-picker
            v-else-if="formItem.element.type === elementTypeData.minute.value"
            class="main"
            :disabled="!isEdit"
            :inputReadOnly="isPad"
            @change="valueChange"
            value-format="mm:ss"
            format="mm:ss"
            v-model="form[formItem.id]"
            :open.sync="timeOpen"
            allowClear
          >
            <a-button slot="addon" size="small" type="primary" @click="handleTimeClose">
              关闭
            </a-button>
          </a-time-picker>


          <!-- 二维码 -->
          <div v-else-if="formItem.element.type === elementTypeData.qrCode.value">
            扫码功能暂未开放
          </div>

          <!-- 文件 -->
          <div v-else-if="formItem.element.type === elementTypeData.file.value">
            <j-upload
              v-model="fileList"
              :bizPath="`/project/${projectId}/patient/form/${formItem.id}/${fileType}`"
              multiple
              @change2="path => onFileChange(path)"
            >
              <a-button icon="upload" size="small">点击上传</a-button>
            </j-upload>
          </div>

          <!-- 滑块 -->
          <a-row
            v-else-if="formItem.element.type === elementTypeData.slider.value"
            style="float: left"
            :id="formItem.id + '_input'"
          >
            <a-col :span="18">
              <a-slider
                :disabled="!isEdit"
                @afterChange="valueChange"
                :marks="marks"
                v-model="form[formItem.id]"
                :min="formItem.element.minLength || 0"
                :max="formItem.element.length || 100"
              />
            </a-col>
            <a-col :span="4" style="margin-top: 10px">
              <a-input-number
                v-model="form[formItem.id]"
                :max="formItem.element.length || 100"
                style="margin-left: 20px"
                :disabled="true"
                :min="formItem.element.minLength || 0"
              />
            </a-col>
          </a-row>

          <!-- 动态表格 -->
          <div
            v-else-if="formItem.element.type === 'table'"
            class="kk-table-9136076486841527 bordered bright">
            <table style="width: 100%">
              <tbody>
                <tr v-for="(row, rowIndex) in normalizedTableRows" :key="rowIndex">
                  <template v-for="(cell, colIndex) in row.tds">
                    <td v-if="isVisibleCell(cell)"
                            :key="`${rowIndex}-${colIndex}`"
                            :rowspan="cell.rowspan"
                            :colspan="cell.colspan"
                            :class="['dynamic-table-cell', !isInputCell(cell) && cell.inputType !== 'checkbox' ? 'table-header-cell' : '']">
                        <!-- === 删除操作列 === -->
                        <!-- <template v-if="cell.inputType === 'delAction'">
                          <div style="display: flex; justify-content: center; align-items: center;">
                            <a-popconfirm
                              title="确定要删除这一行数据吗？此操作不可恢复。"
                              ok-text="确定"
                              cancel-text="取消"
                              @confirm="handleDeleteRow(rowIndex)"
                              ok-type="danger"
                            >
                              <a-icon 
                                type="delete"
                                :disabled="!isEdit"
                                style="color: #ff4d4f; font-size: 16px; cursor: pointer;" 
                                title="删除行"
                              />
                            </a-popconfirm>
                          </div>
                        </template> -->

                        <template v-if="cell.inputType === 'checkbox'">
                          <a-checkbox-group
                            :disabled="!isEdit"
                            :value="getTableCellValue(cell, rowIndex, colIndex) || []"
                            @change="val => { setTableCellValue(cell, rowIndex, colIndex, val); valueChange(); }"
                          >
                            <a-checkbox 
                              v-for="opt in cell.options" 
                              :key="opt.value" 
                              :value="opt.value"
                            >
                              {{ opt.label }}
                            </a-checkbox>
                          </a-checkbox-group>
                        </template>

                        <!-- <template v-else-if="cell.inputType === 'radio'">
                          <a-radio-group
                            :disabled="!isEdit"
                            :value="getTableCellValue(cell, rowIndex, colIndex) || ''"
                            @change="val => { setTableCellValue(cell, rowIndex, colIndex, val.target.value); valueChange(); }"
                          >
                            <a-radio 
                              v-for="opt in cell.options" 
                              :key="opt.value" 
                              :value="opt.value"
                            >
                              {{ opt.label }}
                            </a-radio>
                          </a-radio-group>                          
                        </template> -->

                        <template v-else-if="cell.inputType === 'radio'">
                          <a-select placeholder="请选择" allowClear
                            :disabled="!isEdit"
                            :value="getTableCellValue(cell, rowIndex, colIndex) || ''"
                            @change="val => { setTableCellValue(cell, rowIndex, colIndex, val); valueChange(); }">
                            <a-select-option
                              v-for="opt in cell.options"
                              :key="opt.value" 
                              :value="opt.value"
                            >
                              {{ opt.label }}
                            </a-select-option>
                          </a-select>
                        </template>

                        <template v-else-if="isInputCell(cell)">
                          <a-input
                            :disabled="!isEdit"
                            :value="getTableCellValue(cell, rowIndex, colIndex)"
                            @change="e => setTableCellValue(cell, rowIndex, colIndex, e.target.value)"
                            @blur="valueChange"
                            placeholder="请输入"
                          />
                        </template>

                        <template v-else>
                          <div class="table-cell-text">{{ cell.text }}</div>
                        </template>
                    </td>
                  </template>
                </tr>
              </tbody>
            </table>
            <div class="table-action-bar" v-if="isEdit && isEditRow">
              <a-button type="dashed" block @click="handleAddRow" class="add-row-btn">
                <a-icon type="plus" /> 
                <span>添加一行</span>
              </a-button>
              <a-button type="dashed" block @click="handleDeleteRow" class="add-row-btn">
                <a-icon type="delete" /> 
                <span>删除最后一行</span>
              </a-button>
            </div>
          </div>

          <!-- 未知 -->
          <div v-else>
            未知的元素
          </div>

          <label v-if="formItem.element">{{ formItem.element.unit || '' }}</label>
        </a-space>
      </a-col>
    </a-row>
  </template>


<script>
import JUpload from "@comp/jeecg/JUpload";
import JImageDraw from "@/components/jeecg/JImageDraw";
import { elementTypeData, CACHE_PROJECT_ID, CACHE_IS_PAD } from "@/constants/project";
import { ACCESS_TOKEN } from "@/store/mutation-types";
import Vue from "vue";
import { getAction, postAction, deleteAction } from '@/api/manage'

export default {
  name: "FormViewItemInput",
  components: {
    JUpload,
    JImageDraw
  },
  props: {
    formItem: {
      type: Object,
      default: () => ({})
    },
    form: {
      type: Object,
      default: () => ({})
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    enforcement: {
      type: Boolean,
      default: false
    },
    baseData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      projectId: Vue.ls.get(CACHE_PROJECT_ID),
      isPad: Vue.ls.get(CACHE_IS_PAD),
      elementTypeData,
      timeOpen: false,
      tokenHeader: { "X-Access-Token": Vue.ls.get(ACCESS_TOKEN) },
      fileType: "2",
      open: false,
      fileList: []
    };
  },
  computed: {
    isTemplate() {
      return !this.formItem.formItemId;
    },
    isEdit() {
      return (
        this.enforcement ||
        (!this.readOnly && this.formItem.disabled !== "1") ||
        this.isTemplate
      );
    },
    isDrawImg() {
      return this.baseData.status == "1" || this.baseData.status == "2";
    },
    isEditImg() {
      return (
        this.formItem.drawImg != "" &&
        this.formItem.drawImg != null &&
        this.formItem.drawImg != "undefined"
      );
    },
    marks() {
      const length = this.formItem.element.length || 100;
      const minLength = this.formItem.element.minLength || 0;
      const half = parseInt((length - minLength) / 2);

      const marks = {
        0: `${minLength}`
      };
      if (half > minLength) {
        marks[half + minLength] = `${half + minLength}`;
      }
      marks[length] = `${length}`;
      return marks;
    },
    importExcelUrl() {
      return `${window._CONFIG["domianURL"]}/sys/common/upload`;
    },
    maxInputLength() {
      return this.formItem.element.length || 100000;
    },
    // 优化后：只负责返回已经标准化的表格数据
    normalizedTableRows() {
      return this.getNormalizedTableRows();
    },
    isEditRow(){
      const rows = this.normalizedTableRows || [];
      return rows.some(row => row.isAddRow);
    },
  },
  created() {
    if (this.formItem.value && this.formItem.value.includes("/")) {
      let files = this.formItem.value.split("、");
      for (let i = 0; i < files.length - 1; i += 2) {
        this.fileList.push({
          name: files[i],
          path: files[i + 1],
          type: 10
        });
      }
    }

    this.initTableFormValue();
  },
  watch: {
    normalizedTableRows: {
      handler() {
        this.initTableFormValue();
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    setTimeout(() => {
      this.$nextTick(() => {
        const div = document.getElementById(this.formItem.id + "_input");
        if (div && div.parentNode && div.parentNode.parentNode) {
          const sParent = div.parentNode.parentNode;
          div.style.width = sParent.clientWidth * 0.9 + "px";
        }
      });
    }, 1);
  },
  methods: { 
    valueChange() {
      this.$emit(
        "valueChange",
        { id: this.formItem.id, name: this.formItem.name },
        this.form[this.formItem.id]
      );
    },

    handleTimeClose() {
      this.timeOpen = false;
    },

    clickHandle(value) {
      this.$nextTick(() => {
        if (this.form[this.formItem.id] === value) {
          this.form[this.formItem.id] = null;
        }
      });
    },

    onFileChange(path) {
      this.$set(this.form, this.formItem.id, path);
    },

    saveDrawChange(path) {
      this.$set(this.formItem, "drawImg", path);
      this.$set(this.form, this.formItem.id + "_drawImg", path);
    },

     // 安全解析 trs
    parseTableSource() {
      const raw =this.formItem.trs;
      if (Array.isArray(raw)) return raw;
      if (typeof raw === "string") {
        try {
          const parsed = JSON.parse(raw);
          return Array.isArray(parsed) ? parsed : [];
        } catch (e) {
          console.error("表格 trs JSON 解析失败：", e);
          return [];
        }
      }

      return [];
    },
    handleAddRow(){
      let trs =this.formItem.trs;
      let raw = [];
      console.log('trs',trs)
      if (!Array.isArray(trs)) {
        try {
          raw = JSON.parse(trs);          
        } catch (e) {
          return this.$message.error('添加行失败');
        }
      }
      if(!raw || !raw.length || raw.length < 1){
        return this.$message.error('添加行失败');
      }
      // 获取最后一个元素
      const lastItem = raw[raw.length - 1];
      console.log("tds----:",lastItem.tds)      
            
      // 将其追加到数组末尾
      raw.push(lastItem);
      this.$set(this.formItem, "trs", JSON.stringify(raw));
      postAction('/patient/patientFormItem/updateTrs', {projectId: this.formItem.projectId, id: this.formItem.id, trs: JSON.stringify(raw)}).then(res => {
        if (res.success) {
          this.$message.success('添加行成功');
        }
      }).finally(() => {
      })
    },
    handleDeleteRow(rowIndex) {
      let trs = this.formItem.trs;
      let raw = [];
      console.log('trs',trs)
      if (!Array.isArray(trs)) {
        try {
          raw = JSON.parse(trs);          
        } catch (e) {
          return this.$message.error('添加行失败');
        }
      }
      if(!raw || !raw.length || raw.length <= 2){
        return this.$message.warning('不能删除所有行数据');
      }
      if(rowIndex && rowIndex > 0){
        //删除对应索引的行
        raw.splice(rowIndex, 1);
      }else{
        //删除最后一行
        raw.splice(raw.length - 1, 1);
      }
      this.$set(this.formItem, "trs", JSON.stringify(raw));
      //触发变更通知
      postAction('/patient/patientFormItem/updateTrs', {projectId: this.formItem.projectId, id: this.formItem.id, trs: JSON.stringify(raw)}).then(res => {
        if (res.success) {
          this.$message.success('删除行成功');
        }
      }).finally(() => {
      })
    },

  // 标准化表格数据
  // 修改 getNormalizedTableRows 方法
getNormalizedTableRows() {
  const source = this.parseTableSource();
  if (!Array.isArray(source)) return [];

  return source.map((row) => {
    return {
      tds: Array.isArray(row.tds)
        ? row.tds.map((cell) => {
            const firstItem = Array.isArray(cell.list) && cell.list.length ? cell.list[0] : null;

            let text = "";
            let model = "";
            let inputType = "text";
            let options = []; // 新增：用于存储复选框选项

            if (firstItem && typeof firstItem === "object") {
              text = firstItem.label || "";
              model = firstItem.model || "";
              inputType = firstItem.type || "input";
              options = firstItem.options || []; // 提取 options
            } else if (typeof firstItem === "string") {
              text = firstItem;
            }

            return {
              colspan: Number(cell.colspan) || 0,
              rowspan: Number(cell.rowspan) || 0,
              text,
              model,
              inputType,
              options, // 暴露给模板
              raw: cell
            };
          })
        : [],
      isAddRow: row.isAddRow || false,
    };
  });
},

  // 是否显示单元格
  isVisibleCell(cell) {
  return Number(cell && cell.rowspan) > 0 && Number(cell && cell.colspan) > 0;
  },

  // 是否输入单元格：文本为空时视为输入框
  isInputCell(cell) {
    return (cell && cell.text || "") === "";
  },

  // 获取单元格字段 key：优先用 model，没有再退回 row_col
  getTableCellFieldKey(cell, rowIndex, colIndex) {
   // 如果 cell 里面自带 model (比如设计器定义的唯一标识)，优先使用
  if (cell.model) return cell.model;
  
  // 否则使用标准的 rowIndex_colIndex 格式
  return `${rowIndex}_${colIndex}`;
  },

  // 初始化表格值
  initTableFormValue() {
   if (!this.formItem || !this.formItem.element || this.formItem.element.type !== "table") {
    return;
  }

  // 1. 核心回显逻辑：解析后端传来的 value 字符串/对象
  let initialValue = {};
  try {
    const rawValue = this.form[this.formItem.id] || this.formItem.value;
    if (typeof rawValue === 'string' && rawValue.startsWith('{')) {
      initialValue = JSON.parse(rawValue);
    } else if (typeof rawValue === 'object' && rawValue !== null) {
      initialValue = rawValue;
    }
  } catch (e) {
    console.error("解析表格 Value 失败", e);
  }

  // 2. 确保响应式更新
  if (JSON.stringify(this.form[this.formItem.id]) !== JSON.stringify(initialValue)) {
    this.$set(this.form, this.formItem.id, initialValue);
  }

  // 3. 补全缺失的字段结构（可选，用于初始化空表格）
  const rows = this.normalizedTableRows || [];
  rows.forEach((row, rowIndex) => {
    (row.tds || []).forEach((cell, colIndex) => {
      if (!this.isVisibleCell(cell) || !this.isInputCell(cell)) return;
      const fieldKey = this.getTableCellFieldKey(cell, rowIndex, colIndex);
      if (this.form[this.formItem.id][fieldKey] === undefined) {
        this.$set(this.form[this.formItem.id], fieldKey, "");
      }
    });
  });
  },

  // 获取单元格值
  getTableCellValue(cell, rowIndex, colIndex) {
    debugger;
    console.log("getTableCellValue------");
    const tableData = this.form[this.formItem.id];
    if (!tableData) return "";
    
    const fieldKey = this.getTableCellFieldKey(cell, rowIndex, colIndex);
    return tableData[fieldKey] || "";
  },

  // 设置单元格值
  setTableCellValue(cell, rowIndex, colIndex, value) {
    console.log("setTableCellValue------");
   const fieldKey = this.getTableCellFieldKey(cell, rowIndex, colIndex);
    
    // 确保对象存在
    if (!this.form[this.formItem.id] || typeof this.form[this.formItem.id] !== 'object') {
      this.$set(this.form, this.formItem.id, {});
    }
    // 直接在原对象上设置，触发 Vue 的响应式
    this.$set(this.form[this.formItem.id], fieldKey, value);
  }
  }
};
</script>

<style scoped lang="less">
.row-block {
  display: block;
  line-height: 30px;
  float: left;
}

.max-height-img {
  max-height: 280px;
  width: auto;
}

.auto-distribute {
  display: flex;
  width: 100%;
}

.kk-table-9136076486841527 {
  width: 100%;

  table {
    width: 100%;
    border-collapse: collapse;
    table-layout: fixed;
    background: #fff;
  }

  &.bordered {
    .dynamic-table-cell {
      border: 1px solid #e8e8e8;
    }
  }

  &.bright {
    .dynamic-table-cell:hover {
      background: #e6f7ff;
    }
  }

  .dynamic-table-cell {
    padding: 2px 4px;
    text-align: center;
    vertical-align: middle;
    background: #fff;
    min-width: 80px;
    word-break: break-word;
    /* 2. 强制控制行高，防止撑开 */
    line-height: 1.2;
  }

  .table-cell-text {
    min-height: 18px;
    line-height: 18px;
    text-align: center;
    word-break: break-word;
    white-space: pre-wrap;
    font-weight: 500;
    font-size: 13px; /* 可选：稍微缩小字号 */
  }

  .ant-input {
    width: 100%;
    height: 28px;
   padding: 0 4px;
    font-size: 13px;
  }
  /* 操作栏容器：增加顶部间距，确保与表格分离但视觉上关联 */
  .table-action-bar {
    margin-top: 12px;
    display: flex;
    justify-content: flex-end; /* 右对齐，符合大多数表单习惯；若需居中可改为 center */
  }

  /* 按钮样式优化 */
  .add-row-btn {
    max-width: 200px; /* 限制最大宽度，避免在宽屏下按钮过长 */
    transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
    border-color: #d9d9d9;
    color: rgba(0, 0, 0, 0.65);
  }

  /* 悬停效果：变成主色调，增强点击欲望 */
  .add-row-btn:hover {
    border-color: #1890ff; /* Ant Design 默认主色 */
    color: #1890ff;
    box-shadow: 0 2px 0 rgba(24, 144, 255, 0.2);
  }

  /* 点击时的激活态 */
  .add-row-btn:active {
    transform: scale(0.98);
  }

  /* 如果是虚线边框类型 (type="dashed")，悬停时也可以稍微加深虚线颜色 */
  .ant-btn-dashed.add-row-btn:hover {
    border-color: #1890ff;
    color: #1890ff;
  }
}
</style>

